var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDrawerRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.3672,
    y: 23.9868,
    width: 23,
    height: 23,
    rx: 6.11964,
    transform: "rotate(-180 23.3672 23.9868)",
    fill: "#FC6524"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2008 15.6291C10.0343 15.4627 10.0343 15.1929 10.2008 15.0264L12.854 12.3732L10.2008 9.71992C10.0343 9.5535 10.0343 9.28368 10.2008 9.11726C10.3672 8.95084 10.637 8.95084 10.8034 9.11726L13.758 12.0718C13.9244 12.2383 13.9244 12.5081 13.758 12.6745L10.8034 15.6291C10.637 15.7955 10.3672 15.7955 10.2008 15.6291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDrawerRightIcon);
export default __webpack_public_path__ + "static/media/open-drawer-right-icon.c2a9a2d2b090b853af5afecbf574c620.svg";
export { ForwardRef as ReactComponent };